define('fukit/view/common/segmented.table.view',['require','exports','module','underscore','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _     = require('underscore'),
      UIKit = require('uikit/uikit');

  var tableViewBindings = {
    collection: 'collection',
    model: 'model'
  };

  _.each(UIKit.Table.prototype.options, function(defaultValue, key) {
    tableViewBindings[key] = key;
  });


  var SegmentedTableView = UIKit.Table.extend({

    tagName: 'div',

    className: 'ui segment fitted',

    template: function() {
      return '<table class="'
        + UIKit.Table.prototype.className
        + '">'
        + UIKit.Table.prototype.template.apply(this, arguments)
        + '</table>';
    },

    options: _.extend({}, UIKit.Table.prototype.options, {
      basic: false,
      selectable: true,
      borderless: true,
      attached: false
    }),

    ui: {
      table: 'table',
      childrenContainer: 'tbody',
      header: 'thead > tr:first-child',
      responsiveHeader: 'thead > tr.responsive.sort',
      itemCount: 'tfoot .item.count'
    },

    clearClassNames: function() {
      var cache = this._classNameCache || [];
      for (var i = 0, len = cache.length, className; i < len; i++) {
        className = cache[i];
        this.ui.table.removeClass(className);
      }
      this._classNameCache = [];
      return this;
    },

    addClass: function(className, shouldAdd) {
     var cache     = this._classNameCache || (this._classNameCache = []);

      shouldAdd = arguments.length > 1 ? shouldAdd : true;

      if (shouldAdd === true) {
        cache.push(className);
        this.ui.table[0].className += (' ' + String(className).trim());
      }

      return this;
    },

    updateAttributes: function() {
      UIKit.Table.prototype.updateAttributes.apply(this, arguments);
      this.$el.removeClass('top bottom attached');

      if (this.getBoolOption('attached')) {
        switch (this.getOption('attached')) {
          case 'top':
            this.$el.addClass('top attached');
            break;
          case 'bottom':
            this.$el.addClass('bottom attached');
            break;
          default:
            this.$el.addClass('attached');
            break;
        }
      }
    }

  });

  module.exports = SegmentedTableView;
});

